<template>
  <b-button class="float-right m-1" size="sm" variant="outline-secondary" @click="agir">
    <font-awesome-icon icon="chevron-left" class="mx-1 mx-sm-0 mr-sm-2" />
    <span class="d-none d-sm-inline">Voltar</span>
  </b-button>
</template>

<script>
/**
 * Um botão simples, formatado para ser renderizado nos cabeçalhos de card de nossas páginas.
 * @since 20220502
 */
export default {
  name: "BtnVoltar",
  props: {
    url: { type: String, default: "" },
  },
  methods: {
    agir() {
      if (this.url === '')
        this.$router.go(-1)
      else
        this.$router.push(this.url)
    }
  }
};
</script>